module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector-02-c 2.f6d226e5.png";